/* eslint-disable sonarjs/no-duplicated-branches */
import React from 'react';

import { useHistory } from 'react-router-dom';

import { CoreHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import {
	UseFetchServiceErrorItem,
	useDidMount,
	useShowHide,
} from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';

import { GLOBAL_LOADER } from './components/globalLoader';
import { ApiConfig } from './configs/envVarsValues';
import { getSavedTokenDataFromStorage, saveTokenDataFromStorage } from './helpers/sessionHelper';

interface FetchResponse {
	data: {
		token: {
			accessToken: string;
			expiresIn: number;
			extendedExpiresIn: number;
			refreshToken: string;
		};
		applicationData: {
			applicationParameters: Record<string, Record<string, any>>;
		};
		externalInfo: {
			state: string;
			ott: string;
			contextId: string;
			MSE_ott_ext_app: string;
			returnUrl: string;
			languageCode: string;
		};
	};
	metadata: {
		success: boolean;
		errors: UseFetchServiceErrorItem[];
	};
}

interface FetchTokenProps {
	children: React.ReactNode;
}

export const FetchToken: React.FC<FetchTokenProps> = ({ children }) => {
	//ENABLED GET REQUEST
	//IZIBIZI
	const state = getSavedTokenDataFromStorage('state');

	//IZIBIZI/MSE/FEE
	const contextId = getSavedTokenDataFromStorage('contextId');
	//FEE
	const ott = getSavedTokenDataFromStorage('ott');
	//MSE/FEE

	const tokenOAuth = getSavedTokenDataFromStorage('tokenOAuth');
	const returnUrl = getSavedTokenDataFromStorage('returnUrl');

	//CHECK THE CONTEXT
	const [isInitializedApp, setIsInitializedApp] = React.useState(state || contextId ? true : false);

	const { hide, show } = useShowHide(GLOBAL_LOADER);
	// use history instead of navigate = useNavigation, because redux isn't initialized
	const history = useHistory();

	// const dispatch = useDispatch();

	useDidMount(() => {
		let accessFetchToken = false;
		//Lets run FEE without /token

		const getRequestBypass =
			!CoreHelper.isNullOrEmpty(tokenOAuth) ||
			!CoreHelper.isNullOrEmpty(ott) ||
			!CoreHelper.isNullOrEmpty(contextId) ||
			!CoreHelper.isNullOrEmpty(state) ||
			!CoreHelper.isNullOrEmpty(contextId) ||
			!CoreHelper.isNullOrEmpty(returnUrl);

		if (
			process.env.NODE_ENV === 'development' &&
			(ApiConfig.headers.accept.indexOf('1.001.000') > -1 || getRequestBypass)
		) {
			accessFetchToken = false;
			setIsInitializedApp(true);
		} else {
			accessFetchToken = true;
		}

		if (accessFetchToken) {
			show();
			//FOR DEV Purposes, as this component always renders at the moment

			//
			fetch('/token', {
				method: 'get',
				headers: {
					'content-type': 'application/json',
				},
				credentials: 'include',
			})
				.then((res) => res.json())
				.then((res: FetchResponse) => {
					if (res.metadata.success) {
						const state = res.data.externalInfo?.state;
						const ott = res.data.externalInfo?.ott;
						const contextId = res.data.externalInfo?.contextId;
						const accessToken = res.data.token.accessToken;
						const returnURL = res.data.externalInfo?.returnUrl;
						const mseOTT = res.data.externalInfo?.MSE_ott_ext_app;
						const languageCode = res.data.externalInfo.languageCode;

						saveTokenDataFromStorage('state', state);
						saveTokenDataFromStorage('ott', ott);
						saveTokenDataFromStorage('contextId', contextId);
						saveTokenDataFromStorage('tokenOAuth', accessToken);
						saveTokenDataFromStorage('returnUrl', returnURL);
						saveTokenDataFromStorage('mseOTT', mseOTT);
						saveTokenDataFromStorage('languageCode', languageCode);
					} else {
						history.push('generalErrorNOK');
					}
				})
				.catch((err) => {
					history.push('generalErrorNOK');
				})
				.finally(() => {
					hide();
					setIsInitializedApp(true);
				});
		}
	});

	return <>{isInitializedApp !== undefined && isInitializedApp && children}</>;
};
